import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FairsConfiguration } from '@planone/bau365/data-access-fair-data';
import { EnrichedWatchlistItem, selectWatchlistItemId, WatchlistItemIdentity } from '@planone/bau365/data-access-user';

import { ItemType } from '../page-watchlist/page-watchlist.model';

@Component({
  selector: 'bau365-watchlist-results',
  templateUrl: './watchlist-results.component.html',
  styleUrls: ['./watchlist-results.component.scss'],
})
export class WatchlistResultsComponent {
  @Input() fairId?: string;
  @Input() itemTypes: ItemType[] = [];
  @Input() watchlistItems: null | EnrichedWatchlistItem[] = [];
  @Input() screen?: string | null;
  @Input() fairsConfig?: FairsConfiguration | null;

  @Output() deleteItem = new EventEmitter<WatchlistItemIdentity>();
  @Output() shareItem = new EventEmitter<WatchlistItemIdentity>();
  @Output() shareItemAction = new EventEmitter<{ network: string; item: WatchlistItemIdentity }>();

  getItemType(item: WatchlistItemIdentity) {
    return this.itemTypes.find(({ type }) => item.entity_type === type);
  }

  onDeleteItem(item: WatchlistItemIdentity) {
    this.deleteItem.emit(item);
  }

  onShareItem(item: WatchlistItemIdentity) {
    this.shareItem.emit(item);
  }

  onShareItemAction(network: string, item?: WatchlistItemIdentity) {
    if (item) this.shareItemAction.emit({ network, item });
  }

  identifyWatchlistItem(_index: number, watchlistItem: EnrichedWatchlistItem) {
    return selectWatchlistItemId(watchlistItem);
  }
}
